import { S1ProcessID } from "./s1-processid";

export class CompareLayoutRequest {
    oldProcessID: S1ProcessID;
    newProcessID: S1ProcessID;
}